import { render, staticRenderFns } from "./UsersTab.vue?vue&type=template&id=598fa66a"
import script from "./UsersTab.vue?vue&type=script&lang=ts"
export * from "./UsersTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports